import React from 'react';
import { Link } from 'react-router';
import { Icon, Menu, message, Modal, Tag, Form, Input, notification, Row, Col } from 'antd';
import Iconfont from '@/components/Iconfont/Iconfont';
import AccountSettings from '@/containers/usersfrom/AccountSettings';
import { clearAuth, logout } from "../../services/global";
import { createFeedback } from "../../services/feedback";
import { findLivestreamConfig } from "../../services/website";
import CkInfoItem from "../CkInfoItem";
import HelpVideo from "../../containers/HelpVideo";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { mobile_url_domin } from "../../utils/config";

const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;
const SubMenu = Menu.SubMenu;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};

class BizNavbarMenu extends React.Component {
    render() {

        return (
            <Menu
                selectedKeys={[this.props.selectedKey]}
                className={"nav-module"}
                theme="light"
                mode="horizontal">
                <Menu.Item key="/admin/evtm">
                    <Link to={'/admin/evtm'}>管理中心</Link>
                </Menu.Item>
                <Menu.Item key="/admin/acct">
                    <Link to={'/admin/acct'}>账户&发票</Link>
                </Menu.Item>
                {/*<Menu.Item key="/admin/membership">

                    <Link to={'/admin/membership'}>
                        <span>会员管理</span><Tag color="#f50" style={{marginTop: 1, verticalAlign: "top", position: "absolute", left: 58, top: -2}} className="table-font-xs-small">限时优惠</Tag>
                    </Link>

                </Menu.Item>*/}
                <Menu.Item key="/admin/mall">
                    <Link to={'/admin/mall'}>
                        <span>在线商城</span><Tag color="#f50" style={{ marginTop: 1, verticalAlign: "top", position: "absolute", left: 58, top: -2 }} className="table-font-xs-small">买会员送签币</Tag>
                    </Link>
                </Menu.Item>
            </Menu>
        )
    }
}

class BizEvtmNavbarMenu extends React.Component {
    constructor(props) {
        console.log(props)
        super(props);
        this.state = {
            liveSwitch: true
        }
    }

    componentDidMount() {
        findLivestreamConfig().then(res => {
            if (res.code === 200) {
                this.setState({ liveSwitch: res.data });
            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
    }
    render() {
        return (
            <Menu theme="dark" mode="inline" selectedKeys={[this.props.selectedKey]} >
                <Menu.Item key="/admin/evtm/dashboard">
                    <Link to={'/admin/evtm/dashboard'}>
                        <Iconfont libname="ckicon" type="app" />
                        <span className="nav-text">概况</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="/admin/evtm/evt">
                    <Link to={'/admin/evtm/evt'}>
                        <Iconfont libname="ckicon" type="huodong" />
                        <span className="nav-text">活动管理</span>
                    </Link>
                </Menu.Item>
                <SubMenu key="sub2" title={<span><Iconfont libname="ckicon" type="guanli" /><span className="nav-text">跨活动管理</span></span>}>
                    <Menu.Item key="/admin/evtm/pubilshedtotal">
                        <Link to={'/admin/evtm/pubilshedtotal'}>
                            <span className="nav-text">活动查询</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/evtm/history/register">
                        <Link to={'/admin/evtm/history/register'}>
                            <span className="nav-text">报名签到记录</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/evtm/event-groups">
                        <Link to={'/admin/evtm/event-groups'}>
                            <span className="nav-text">活动列表分享</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/evtm/attendeecredit-status">
                        <Link to={'/admin/evtm/attendeecredit-status'}>
                            <span className="nav-text">签到积分</span>
                        </Link>
                    </Menu.Item>

                </SubMenu>
                <SubMenu key="sub3" title={<span><Iconfont libname="ckicon" type="wenjuan" /><span className="nav-text">问卷投票</span></span>}>
                    <Menu.Item key="/admin/evtm/questionnaire">
                        <Link to={'/admin/evtm/questionnaire'}>
                            <span className="nav-text">问卷调查</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/evtm/votes">
                        <Link to={'/admin/evtm/votes'}>
                            <span className="nav-text">大屏投票</span>
                        </Link>
                    </Menu.Item>
                </SubMenu>
                <Menu.Item key="/admin/evtm/interact-lists">
                    <Link to={'/admin/evtm/interact-lists'}>
                        <Iconfont libname="ckicon" type="jingcai" />
                        <span className="nav-text">现场互动</span>
                    </Link>
                </Menu.Item>
                {
                    this.state.liveSwitch &&
                    <Menu.Item key="/admin/evtm/livestream">
                        <Link to={'/admin/evtm/livestream'}>
                            <Iconfont libname="ckicon" type="zhibo" />
                            <span className="nav-text">会议直播</span>
                        </Link>
                    </Menu.Item>
                }

                <Menu.Item key="/admin/evtm/guest-library">
                    <Link to={'/admin/evtm/guest-library'}>
                        <Iconfont libname="ckicon" type="jiabinguanli1" />
                        <span className="nav-text">嘉宾库</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="/admin/evtm/contacts">
                    <Link to={'/admin/evtm/contacts'}>
                        <Iconfont libname="ckicon" type="tongxunlu" />
                        <span className="nav-text">通讯录</span>
                    </Link>
                </Menu.Item>

                <Menu.Item key="/admin/evtm/msglog">
                    <Link to={'/admin/evtm/msglog'}>
                        <Iconfont libname="ckicon" type="duanxin" />
                        <span className="nav-text">短信邮件任务</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="/admin/evtm/wechatauth">
                    <Link to={'/admin/evtm/wechatauth'}>
                        <Iconfont libname="ckicon" type="duanxinyingxiao" />
                        <span className="nav-text">微信授权</span>
                    </Link>
                </Menu.Item>
            </Menu>
        )
    }
}


class BizEvtmEvtNavbarMenu extends React.Component {
    render() {
        return (
            <Menu theme="light" mode="inline" selectedKeys={[this.props.selectedKey]}>
                <Menu.Item key={`${this.props.preLocationPath}/:evtId/dashboard`}>
                    <Link to={`${this.props.preLocationPath}/${this.props.evtId}/dashboard`}>
                        <Iconfont libname="ckicon" type="icon-test" />
                        <span className="nav-text">管理中心</span>
                    </Link>
                </Menu.Item>



                <MenuItemGroup key="g1" title="邀约报名">
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/invitation`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/invitation`}>
                            <Iconfont libname="ckicon" type="yaoqinghan1" />
                            <span className="nav-text">短信群发邀约</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/share`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/share`}>
                            <Iconfont libname="ckicon" type="fenxiang2" />
                            <span className="nav-text">微信邀约-H5</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/microsite`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/microsite`}>
                            <Iconfont libname="ckicon" type="jiugongge" />
                            <span className="nav-text">微信邀约-九宫格</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/inset`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/inset`}>
                            <Iconfont libname="ckicon" type="zhuanxianjieru" />
                            <span className="nav-text">网页嵌入</span>
                        </Link>
                    </Menu.Item>
                    {/*<Menu.Item key={`${this.props.preLocationPath}/:evtId/publicevent`}>*/}
                    {/*<Link to={`${this.props.preLocationPath}/${this.props.evtId}/publicevent`}>*/}
                    {/*<Iconfont libname="ckicon" type="tuiguang"/>*/}
                    {/*<span className="nav-text">公开活动</span>*/}
                    {/*</Link>*/}
                    {/*</Menu.Item>*/}
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/promote`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/promote`}>
                            <Iconfont libname="ckicon" type="templet" />
                            <span className="nav-text">固定渠道营销</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/wx-promote`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/wx-promote`}>
                            <Iconfont libname="ckicon" type="duanxinyingxiao" />
                            <span className="nav-text">二级活码营销</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/invitation-code`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/invitation-code`}>
                            <Iconfont libname="ckicon" type="yaoqingma" />
                            <span className="nav-text">报名邀请码</span>
                        </Link>
                    </Menu.Item>
                </MenuItemGroup>

                <MenuItemGroup key="g5" title="签到">
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/attendee`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/attendee`}>
                            <Iconfont libname="ckicon" type="yonghu" />
                            <span className="nav-text">参与人</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/confirmation`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/confirmation`}>
                            <Iconfont libname="ckicon" type="querenhan" />
                            <span className="nav-text">设计确认函</span>
                        </Link>
                    </Menu.Item>

                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/allot`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/allot`}>
                            <Iconfont libname="ckicon" type="fenpei" />
                            <span className="nav-text">分配房间座位</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/checkinlog`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/checkinlog`}>
                            <Iconfont libname="ckicon" type="icon-test1" />
                            <span className="nav-text">签到记录（实时）</span>
                        </Link>
                    </Menu.Item>
                    {/* <Menu.Item key={`${this.props.preLocationPath}/:evtId/attendeecredit-status`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/attendeecredit-status`}>
                            <Iconfont libname="ckicon" type="weibiaoti2fuzhi01" />
                            <span className="nav-text">签到积分统计</span>
                        </Link>
                    </Menu.Item> */}
                    {
                        localStorage.getItem('userId') == '1244480807142166530' &&
                        <Menu.Item key={`${this.props.preLocationPath}/:evtId/wjwattendee-status`}>
                            <Link to={`${this.props.preLocationPath}/${this.props.evtId}/wjwattendee-status`}>
                                <Iconfont libname="ckicon" type="weibiaoti2fuzhi01" />
                                <span className="nav-text">卫健委统计</span>
                            </Link>
                        </Menu.Item>}
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/ticketorder`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/ticketorder`}>
                            <Iconfont libname="ckicon" type="dingdan" />
                            <span className="nav-text">报名收费订单</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/attendee-invoices`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/attendee-invoices`}>
                            <Iconfont libname="ckicon" type="xiaoshoufapiaoguanli-normal" />
                            <span className="nav-text">活动发票申请</span>
                        </Link>
                    </Menu.Item>

                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/notetemplate`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/notetemplate`}>
                            <Iconfont libname="ckicon" type="zhengshu" />
                            <span className="nav-text">结业证书</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/thermal-printing`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/thermal-printing`}>
                            <Iconfont libname="ckicon" type="dayin1" />
                            <span className="nav-text">打印胸牌</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/comments`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/comments`}>
                            <Iconfont libname="ckicon" type="pinglun" />
                            <span className="nav-text">活动评论</span>
                        </Link>
                    </Menu.Item>
                </MenuItemGroup>

                {/*<MenuItemGroup key="g3" title="抽奖">*/}
                {/*<Menu.Item key={`${this.props.preLocationPath}/:evtId/luckydraw`}>*/}
                {/*<Link to={`${this.props.preLocationPath}/${this.props.evtId}/luckydraw`}>*/}
                {/*<Iconfont libname="ckicon" type="choujiang"/>*/}
                {/*<span className="nav-text">现场抽奖</span>*/}
                {/*</Link>*/}
                {/*</Menu.Item>*/}
                {/*<Menu.Item key={`${this.props.preLocationPath}/:evtId/jackpot`}>*/}
                {/*<Link to={`${this.props.preLocationPath}/${this.props.evtId}/jackpot`}>*/}
                {/*<Iconfont libname="ckicon" type="dingdan-"/>*/}
                {/*<span className="nav-text">奖池</span>*/}
                {/*</Link>*/}
                {/*</Menu.Item>*/}
                {/*<Menu.Item key={`${this.props.preLocationPath}/:evtId/winner`}>*/}
                {/*<Link to={`${this.props.preLocationPath}/${this.props.evtId}/winner`}>*/}
                {/*<Iconfont libname="ckicon" type="duorenyonghu"/>*/}
                {/*<span className="nav-text">中奖名单</span>*/}
                {/*</Link>*/}
                {/*</Menu.Item>*/}
                {/*</MenuItemGroup>*/}

                <MenuItemGroup key="g2" title="现场互动">
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/luckydraw`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/luckydraw`}>
                            <Iconfont libname="ckicon" type="jiangli" />
                            <span className="nav-text">主办方抽奖</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/attendeeluckydrawlist`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/attendeeluckydrawlist`}>
                            <Iconfont libname="ckicon" type="choujiang" />
                            <span className="nav-text">参与人摇奖</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/signin-wall`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/signin-wall`}>
                            <Iconfont libname="ckicon" type="shebeileidianshiqiang" />
                            <span className="nav-text">3D签到墙</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/luckymoney`} style={{ display: 'none' }}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/luckymoney`}>
                            <Iconfont libname="ckicon" type="hongbao" />
                            <span className="nav-text">微信红包雨</span>
                        </Link>
                    </Menu.Item>

                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/guess`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/guess/list`}>
                            <Iconfont libname="ckicon" type="jingcai" />
                            <span className="nav-text">大屏竞猜</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/market`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/market/list`}>
                            <Iconfont libname="ckicon" type="paimai" />
                            <span className="nav-text">现场会销</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/reward`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/reward/list`}>
                            <Iconfont libname="ckicon" type="dashang1" />
                            <span className="nav-text">现场打赏</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/barrage`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/barrage/list`}>
                            <Iconfont libname="ckicon" type="danmu1" />
                            <span className="nav-text">弹幕上墙</span>
                        </Link>
                    </Menu.Item>
                </MenuItemGroup>


                <MenuItemGroup key="g9" title="会员报表">
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/register-and-checkin-stats`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/register-and-checkin-stats`}>
                            <Iconfont libname="ckicon" type="zhibiao2" />
                            <span className="nav-text">报名签到趋势</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/questionnaire-stats`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/questionnaire-stats`}>
                            <Iconfont libname="ckicon" type="wenjuan" />
                            <span className="nav-text">选择题统计</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/checkin-stats`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/checkin-stats`}>
                            <Iconfont libname="ckicon" type="zhibiao1" />
                            <span className="nav-text">签到详情统计</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={`${this.props.preLocationPath}/:evtId/periodicitycheckin-stats`}>
                        <Link to={`${this.props.preLocationPath}/${this.props.evtId}/periodicitycheckin-stats`}>
                            <Iconfont libname="ckicon" type="zhibiao1" />
                            <span className="nav-text">周期性签到统计</span>
                        </Link>
                    </Menu.Item>


                </MenuItemGroup>

            </Menu>
        )
    }
}


class BizAcctNavbarMenu extends React.Component {
    render() {
        return (
            <Menu theme="dark" mode="inline" selectedKeys={[this.props.selectedKey]}>
                <Menu.Item key="/admin/acct/wallet">
                    <Link to={'/admin/acct/wallet'}>
                        <Iconfont libname="ckicon" type="qianbao" />
                        <span className="nav-text">钱包</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="/admin/acct/withdraw">
                    <Link to={'/admin/acct/withdraw'}>
                        <Iconfont libname="ckicon" type="tixian1" />
                        <span className="nav-text">提现</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="/admin/acct/invoice">
                    <Link to={'/admin/acct/invoice'}>
                        <Iconfont libname="ckicon" type="fapiaoxinxi" />
                        <span className="nav-text">发票</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="/admin/acct/cm-order">
                    <Link to={'/admin/acct/cm-order'}>
                        <Iconfont libname="ckicon" type="dingdan" />
                        <span className="nav-text">订单</span>
                    </Link>
                </Menu.Item>
            </Menu>
        )
    }
}

class BizSysmNavbarMenu extends React.Component {
    render() {
        return (
            <Menu theme="light" mode="inline" selectedKeys={[this.props.selectedKey]}>
                <Menu.Item key="/admin/sysm/dashboard">
                    <Link to={'/admin/sysm/dashboard'}>
                        <Iconfont libname="ckicon" type="app" />
                        <span className="nav-text">概况</span>
                    </Link>
                </Menu.Item>
                <MenuItemGroup key="g1" title="系统设置">
                    <Menu.Item key="/admin/sysm/user">
                        <Link to={'/admin/sysm/user'}>
                            <Iconfont libname="ckicon" type="yonghu" />
                            <span className="nav-text">用户</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/sysm/role">
                        <Link to={'/admin/sysm/role'}>
                            <Iconfont libname="ckicon" type="authority" />
                            <span className="nav-text">角色权限</span>
                        </Link>
                    </Menu.Item>
                </MenuItemGroup>
                <MenuItemGroup key="g2" title="客户端管理">
                    <Menu.Item key="/admin/sysm/ios-client">
                        <Link to={'/admin/sysm/ios-client'}>
                            <Iconfont libname="ckicon" type="iOS" />
                            <span className="nav-text">苹果</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/sysm/android-client">
                        <Link to={'/admin/sysm/android-client'}>
                            <Iconfont libname="ckicon" type="ic_android_px" />
                            <span className="nav-text">安卓</span>
                        </Link>
                    </Menu.Item>
                    {/*<Menu.Item key="/admin/sysm/pc-client">
                        <Link to={'/admin/sysm/pc-client'}>
                            <Iconfont libname="ckicon" type="client2"/>
                            <span className="nav-text">PC/MAC</span>
                        </Link>
                    </Menu.Item>*/}
                </MenuItemGroup>
                <MenuItemGroup key="g3" title="通知">
                    <Menu.Item key="/admin/sysm/dynamic">
                        <Link to={'/admin/sysm/dynamic'}>
                            <Iconfont libname="ckicon" type="duihuakuang" />
                            <span className="nav-text">动态</span>
                        </Link>
                    </Menu.Item>
                </MenuItemGroup>
                <MenuItemGroup key="g4" title="配置项">
                    <Menu.Item key="/admin/sysm/invitation-bgm">
                        <Link to={'/admin/sysm/invitation-bgm'}>
                            <Iconfont libname="ckicon" type="beijingyinle" />
                            <span className="nav-text">邀请函背景音乐</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/sysm/invitation-tpl">
                        <Link to={'/admin/sysm/invitation-tpl'}>
                            <Iconfont libname="ckicon" type="templet" />
                            <span className="nav-text">邀请函模板</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/sysm/sms-config">
                        <Link to={'/admin/sysm/sms-config'}>
                            <Iconfont libname="ckicon" type="icon24" />
                            <span className="nav-text">短信渠道分配</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/sysm/customer-config">
                        <Link to={'/admin/sysm/customer-config'}>
                            <Iconfont libname="ckicon" type="kefu" />
                            <span className="nav-text">客服配置</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/sysm/ibeacon-config">
                        <Link to={'/admin/sysm/ibeacon-config'}>
                            <Iconfont libname="ckicon" type="1sss1" />
                            <span className="nav-text">iBeacon管理</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/sysm/appintro-config">
                        <Link to={'/admin/sysm/appintro-config'}>
                            <Iconfont libname="ckicon" type="mobile1151495easyiconnet" />
                            <span className="nav-text">App配置</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/sysm/pay-config">
                        <Link to={'/admin/sysm/pay-config'}>
                            <Iconfont libname="ckicon" type="zhifuqudaoguanli" />
                            <span className="nav-text">商户号配置</span>
                        </Link>
                    </Menu.Item>
                </MenuItemGroup>
            </Menu>
        )
    }
}


class BizSupportNavbarMenu extends React.Component {
    render() {
        return (
            <Menu style={{ height: 'calc(100vh - 112px)' }} theme="light" mode="inline" selectedKeys={[this.props.selectedKey]}>
                <Menu.Item key="/admin/support/dashboard">
                    <Link to={'/admin/support/dashboard'}>
                        <Iconfont libname="ckicon" type="app" />
                        <span className="nav-text">概况</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="/admin/support/offer">
                    <Link to={'/admin/support/offer'}>
                        <Iconfont libname="ckicon" type="feedback" />
                        <span className="nav-text">用户反馈</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="/admin/support/online-user">
                    <Link to={'/admin/support/online-user'}>
                        <Iconfont libname="ckicon" type="zaixianyonghu" />
                        <span className="nav-text">在线用户</span>
                    </Link>
                </Menu.Item>
                <MenuItemGroup key="g1" title="业务">
                    <Menu.Item key="/admin/support/evt">
                        <Link to={'/admin/support/evt'}>
                            <Iconfont libname="ckicon" type="zaixianyonghu" />
                            <span className="nav-text">活动</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/cm-order">
                        <Link to={'/admin/support/cm-order'}>
                            <Iconfont libname="ckicon" type="dingdan" />
                            <span className="nav-text">订单</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/evt-operation">
                        <Link to={'/admin/support/evt-operation'}>
                            <Iconfont libname="ckicon" type="zhibiao2" />
                            <span className="nav-text">活动热度</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/history">
                        <Link to={'/admin/support/history'}>
                            <Iconfont libname="ckicon" type="icon-test1" />
                            <span className="nav-text">报名签到记录</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/guess-list">
                        <Link to={'/admin/support/guess-list'}>
                            <Iconfont libname="ckicon" type="jingcai" />
                            <span className="nav-text">限时竞猜</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/market-list">
                        <Link to={'/admin/support/market-list'}>
                            <Iconfont libname="ckicon" type="huixiaohuodong" />
                            <span className="nav-text">现场会销</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/reward-list">
                        <Link to={'/admin/support/reward-list'}>
                            <Iconfont libname="ckicon" type="dashang" />
                            <span className="nav-text">现场打赏</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/indep-roll">
                        <Link to={'/admin/support/indep-roll'}>
                            <Iconfont libname="ckicon" type="choujiang" />
                            <span className="nav-text">独立摇奖</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/questionnaire">
                        <Link to={'/admin/support/questionnaire'}>
                            <Iconfont libname="ckicon" type="wenjuan" />
                            <span className="nav-text">问卷调查</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/votes">
                        <Link to={'/admin/support/votes'}>
                            <Iconfont libname="ckicon" type="navicon-tp" />
                            <span className="nav-text">大屏投票</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/experience-config">
                        <Link to={'/admin/support/experience-config'}>
                            <Iconfont libname="ckicon" type="hudong" />
                            <span className="nav-text">互动体验配置</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/except-config">
                        <Link to={'/admin/support/except-config'}>
                            <Iconfont libname="ckicon" type="zaixianyonghu" />
                            <span className="nav-text">用户例外配置</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/msglog">
                        <Link to={'/admin/support/msglog'}>
                            <Iconfont libname="ckicon" type="duanxin" />
                            <span className="nav-text">短信邮件任务</span>
                        </Link>
                    </Menu.Item>
                </MenuItemGroup>
                <MenuItemGroup key="g2" title="审核">
                    <Menu.Item key="/admin/support/invoice-verify">
                        <Link to={'/admin/support/invoice-verify'}>
                            <Iconfont libname="ckicon" type="fapiaoxinxi" />
                            <span className="nav-text">发票审核</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/bankcard-verify">
                        <Link to={'/admin/support/bankcard-verify'}>
                            <Iconfont libname="ckicon" type="iconset0291" />
                            <span className="nav-text">银行卡审核</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/withdraw-verify">
                        <Link to={'/admin/support/withdraw-verify'}>
                            <Iconfont libname="ckicon" type="tixian1" />
                            <span className="nav-text">提现审核</span>
                        </Link>
                    </Menu.Item>
                    {/*  <Menu.Item key="/admin/support/refund-verify">
                        <Link to={'/admin/support/refund-verify'}>
                            <Iconfont libname="ckicon" type="5tuikuan"/>
                            <span className="nav-text">退款审核</span>
                        </Link>
                    </Menu.Item>*/}
                    <Menu.Item key="/admin/support/smssign-verify">
                        <Link to={'/admin/support/smssign-verify'}>
                            <Iconfont libname="ckicon" type="duanxin" />
                            <span className="nav-text">短信签名审核</span>
                        </Link>
                    </Menu.Item>
                </MenuItemGroup>
                <MenuItemGroup key="g3" title="指标">
                    <Menu.Item key="/admin/support/withdraw-stats">
                        <Link to={'/admin/support/withdraw-stats'}>
                            <Iconfont libname="ckicon" type="zhibiao2" />
                            <span className="nav-text">可提现统计</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/income-stats">
                        <Link to={'/admin/support/income-stats'}>
                            <Iconfont libname="ckicon" type="zhibiao" />
                            <span className="nav-text">收支统计</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/user-consume-stats">
                        <Link to={'/admin/support/user-consume-stats'}>
                            <Iconfont libname="ckicon" type="zhibiao" />
                            <span className="nav-text">用户消费统计</span>
                        </Link>
                    </Menu.Item>
                </MenuItemGroup>

                <MenuItemGroup key="g4" title="增值服务">
                    <Menu.Item key="/admin/support/vas-topup">
                        <Link to={'/admin/support/vas-topup'}>
                            <Iconfont libname="ckicon" type="bi" />
                            <span className="nav-text">签币充值</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/vas-svc">
                        <Link to={'/admin/support/vas-svc'}>
                            <Iconfont libname="ckicon" type="dingyue" />
                            <span className="nav-text">订阅服务</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/vas-product">
                        <Link to={'/admin/support/vas-product'}>
                            <Iconfont libname="ckicon" type="putongshitishangpin" />
                            <span className="nav-text">实体商品</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/vas-membership">
                        <Link to={'/admin/support/vas-membership'}>
                            <Iconfont libname="ckicon" type="dingdan-" />
                            <span className="nav-text">会员</span>
                        </Link>
                    </Menu.Item>

                </MenuItemGroup>

                <MenuItemGroup key="g5" title="官网">
                    <Menu.Item key="/admin/support/news-casus">
                        <Link to={'/admin/support/news-casus'}>
                            <Iconfont libname="ckicon" type="xinwen" />
                            <span className="nav-text">新闻&案例</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/home-statistics">
                        <Link to={'/admin/support/home-statistics'}>
                            <Iconfont libname="ckicon" type="zhibiao1" />
                            <span className="nav-text">数据管理</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/livestream-config">
                        <Link to={'/admin/support/livestream-config'}>
                            <Iconfont libname="ckicon" type="zhibo" />
                            <span className="nav-text">直播管理</span>
                        </Link>
                    </Menu.Item>
                </MenuItemGroup>
                <MenuItemGroup key="g6" title="赠送">
                    <Menu.Item key="/admin/support/qcoin-transfer" >
                        <Link to={'/admin/support/qcoin-transfer'}>
                            <Iconfont libname="ckicon" type="zhuanxianjieru" />
                            <span className="nav-text">签币转移</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="/admin/support/gift" style={{ marginBottom: 48 }}>
                        <Link to={'/admin/support/gift'}>
                            <Iconfont libname="ckicon" type="zengsongjine" />
                            <span className="nav-text">平台赠送</span>
                        </Link>
                    </Menu.Item>

                </MenuItemGroup>
            </Menu>
        )
    }
}


class HelpMenus extends React.Component {
    state = {
        visible: false,
        feedbackVisible: false,
    }
    showModal = () => {
        this.setState({
            visible: true,
            radioVisible: false,
            mobileRequest: false,
            qqRequest: false,
        });
    }
    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    }
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }
    handleFeedbackVisible = (flag) => {
        this.setState({ feedbackVisible: flag })
    };
    handleFeedbackSubmit = () => {
        this.props.form.validateFieldsAndScroll(['content', 'guestMobile', 'guestQq', 'source'], (err, values) => {
            if (!err) {
                if (values.guestMobile || values.guestQq) {
                    this.setState({
                        mobileRequest: false,
                        qqRequest: false
                    })
                } else {
                    this.setState({ mobileRequest: true }, () => this.props.form.validateFields(['guestMobile'], { force: true }));
                    return;
                }
                createFeedback(values).then(res => {
                    if (res.code === 200) {
                        notification.success({
                            message: '签到家',
                            description: '感谢您的反馈，我们会努力做得更好！',
                        });
                        this.handleFeedbackVisible(false);
                    } else {
                        message.error(res.msg, 6);
                    }
                }).catch(() => message.error("访问异常"));
            }
        });
    };
    render() {
        const { form: { getFieldDecorator } } = this.props;
        const { mobileRequest, qqRequest } = this.state;
        return (
            <div className="navbar-popover">
                <Menu>
                    <Menu.Item key="b1">
                        <a onClick={this.showModal}>
                            <Icon type="customerservice" />
                            在线客服
                        </a>
                    </Menu.Item>
                    <Menu.Item key="b2">
                        <a href="https://www.yuque.com/odh2xi/manual/rq93cagvwtqocxv5" target="_Blank">
                            <Icon type="bulb" />
                            常见问题</a>
                    </Menu.Item>
                    <Menu.Item key="b5">
                        <a href="https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu" target="_Blank">
                            <Icon type="share-alt" />
                            功能介绍</a>
                    </Menu.Item>
                    <Menu.Item key="b3">
                        <a href="https://www.qdj8.cn/share/experienceview" target="_Blank">
                            <Icon type="play-circle-o" />
                            体验专区</a>
                    </Menu.Item>
                    {/*<Menu.Item key="b3">
                        <a onClick={()=>this.setState({radioVisible:true})}>
                            <Icon type="play-circle-o"/>
                            体验</a>
                    </Menu.Item>*/}
                    <Menu.Item key="b4">
                        <a onClick={() => this.handleFeedbackVisible(true)}>
                            <Icon type="pushpin" />
                            我要反馈</a>
                    </Menu.Item>
                </Menu>
                <Modal
                    // width={1000}
                    title="在线客服"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={null}
                >
                    <div>
                        <CkInfoItem label={"客服QQ"}>
                            小美：<a href="https://wpa.qq.com/msgrd?v=3&uin=3455994562&site=qq&menu=yes" target="_Blank">3455994562</a>&nbsp;&nbsp;
                            小悠：<a href="https://wpa.qq.com/msgrd?v=3&uin=2165863680&site=qq&menu=yes" target="_Blank">2165863680</a>
                        </CkInfoItem>
                        <CkInfoItem label={"手机/微信（商务联系）"}>
                            18615776026（漆先生）
                        </CkInfoItem>
                        <CkInfoItem label={"QQ群1（满）"}>
                            211793371
                        </CkInfoItem>
                        <CkInfoItem label={"QQ群2"}>
                            237636476
                        </CkInfoItem>
                    </div>
                </Modal>

                <Modal
                    width={600}
                    title={<div>
                        <p>视频演示</p>
                        <CopyToClipboard text={`${mobile_url_domin}/mobile/videoguide`} onCopy={() => message.success("已复制!")}>
                            <a href="#" style={{ fontSize: 12 }}>复制链接</a>
                        </CopyToClipboard>
                    </div>}
                    visible={this.state.radioVisible}
                    onCancel={() => this.setState({ radioVisible: false })}
                    footer={null}
                >
                    <div>
                        <HelpVideo />
                    </div>
                </Modal>

                <Modal
                    width={600}
                    title={<span><Icon type="pushpin" /> 我要反馈</span>}
                    visible={this.state.feedbackVisible}
                    onCancel={() => this.handleFeedbackVisible(false)}
                    onOk={() => this.handleFeedbackSubmit()}
                >
                    <Form>
                        <FormItem>
                            {getFieldDecorator('content', {
                                rules: [{ required: true, message: '反馈内容不能为空！' }],
                            })(
                                <Input.TextArea placeholder="请输入反馈内容" rows={6} />
                            )}
                        </FormItem>
                        <Row gutter={8}>
                            <Col span={12}>
                                <FormItem>
                                    {getFieldDecorator('guestMobile', {
                                        rules: [
                                            { required: mobileRequest, message: '请输入手机号码!' },
                                            { pattern: /^1\d{10}$/, message: '请输入正确的手机号码！' },
                                        ],
                                    })(
                                        <Input prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="请输入手机" />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem>
                                    {getFieldDecorator('guestQq', {
                                        rules: [
                                            { required: qqRequest, message: '请输入QQ号码!' },
                                            { pattern: /^\d{5,12}$/, message: '请输入正确的QQ!' },
                                            {
                                                validator: (rule, value, callback) => {
                                                    this.setState({ mobileRequest: false }, this.props.form.validateFields(['guestMobile'], { force: true }));
                                                    callback()
                                                }
                                            }
                                        ],
                                    })(
                                        <Input prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="请输入QQ" />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <span style={{ display: 'none' }}>
                            {getFieldDecorator('source', {
                                initialValue: 'PC',
                            })(
                                <Input />
                            )}
                        </span>
                    </Form>
                </Modal>
            </div>
        )
    }
}

class InformMenu extends React.Component {
    render() {
        return (
            <div className="navbar-popover">
                {/*<Menu>*/}
                {/*<Menu.Item key="task1">*/}
                {/*<Icon type="hourglass"/>*/}
                {/*当前任务*/}
                {/*</Menu.Item>*/}
                {/*</Menu>*/}
            </div>
        )
    }
}

class PersonMenu extends React.Component {

    state = {
        visible: false,
        mode: 'inline',
        theme: 'light',
    }
    showModal = () => {
        this.setState({
            visible: true,
        });
    }
    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    }
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }

    changeMode = (value) => {
        this.setState({
            mode: value ? 'vertical' : 'inline',
        });
    }
    changeTheme = (value) => {
        this.setState({
            theme: value ? 'dark' : 'light',
        });
    }

    logout = () => {
        logout().then(res => {
            if (res.code == 200) {
                message.info("退出成功!");
            } else {
                //message.error(res.msg,6);
            }
        }).catch(err => {
            //message.warn("访问异常");
        }).finally(() => {
            clearAuth(true);
        })
    }

    render() {
        return (
            <div className="navbar-popover">
                <Menu>
                    <Menu.Item key="c1">
                        <a onClick={this.showModal}>
                            <Icon type="user" />
                            个人中心
                        </a>
                    </Menu.Item>
                    {/* <Menu.Item key="c2">
                        <Icon type="tool"/>
                        偏好设置
                    </Menu.Item>*/}
                    <Menu.Divider />
                    <Menu.Item key="c3">
                        <a onClick={this.logout}>
                            <Icon type="poweroff" />
                            退出登录
                        </a>
                    </Menu.Item>
                </Menu>
                <Modal
                    width={1000}
                    title="个人中心"
                    maskClosable={false}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={null}
                >
                    {this.state.visible ? <AccountSettings visibleHide={this.handleCancel} /> : ''}
                </Modal>
            </div>
        )
    }
}

const HelpMenu = Form.create()(HelpMenus);

export {
    HelpMenu,
    InformMenu,
    PersonMenu,
    BizNavbarMenu,
    BizEvtmNavbarMenu,
    BizEvtmEvtNavbarMenu,
    BizAcctNavbarMenu,
    BizSysmNavbarMenu,
    BizSupportNavbarMenu
};


// WEBPACK FOOTER //
// ./src/components/ck/CkMenu.jsx